import axios from "axios";

// Backend origin comes from environment only — never hard-coded (spec §2).
const BASE = process.env.REACT_APP_BACKEND_URL || "";

export const api = axios.create({
  baseURL: `${BASE}/api`,
  withCredentials: true, // refresh token cookie (httpOnly)
});

let accessToken = null;
let onUnauthorised = () => {};

export function setAccessToken(token) {
  accessToken = token;
}

export function setUnauthorisedHandler(fn) {
  onUnauthorised = fn;
}

api.interceptors.request.use((cfg) => {
  if (accessToken) {
    cfg.headers.Authorization = `Bearer ${accessToken}`;
  }
  return cfg;
});

let refreshing = null;

/* Single-flight refresh: rotation + reuse detection on the server revokes the
   whole token family if the same refresh token is presented twice, so
   concurrent callers (React StrictMode double-mount, parallel 401 retries)
   must share ONE in-flight request. */
export function refreshSession() {
  if (!refreshing) {
    refreshing = api.post("/auth/refresh").finally(() => {
      setTimeout(() => { refreshing = null; }, 800);
    });
  }
  return refreshing;
}

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const { config, response } = error;
    if (!response || response.status !== 401 || config._retried ||
        (config.url || "").startsWith("/auth/")) {
      throw error;
    }
    config._retried = true;
    try {
      const { data } = await refreshSession();
      accessToken = data.accessToken;
      return api(config);
    } catch (e) {
      accessToken = null;
      onUnauthorised();
      throw error;
    }
  },
);

export function fmtKLTime(iso) {
  if (!iso) return "—";
  return new Intl.DateTimeFormat("en-MY", {
    timeZone: "Asia/Kuala_Lumpur", hour: "2-digit", minute: "2-digit", hour12: true,
  }).format(new Date(iso));
}

export function fmtKLDateTime(iso) {
  if (!iso) return "—";
  return new Intl.DateTimeFormat("en-MY", {
    timeZone: "Asia/Kuala_Lumpur", day: "2-digit", month: "short",
    hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: true,
  }).format(new Date(iso));
}

export function fmtKLDate(isoOrDateStr) {
  if (!isoOrDateStr) return "—";
  const d = isoOrDateStr.length === 10 ? new Date(`${isoOrDateStr}T12:00:00`) : new Date(isoOrDateStr);
  return new Intl.DateTimeFormat("en-MY", {
    timeZone: "Asia/Kuala_Lumpur", weekday: "short", day: "2-digit", month: "short", year: "numeric",
  }).format(d);
}

export function todayKL(offsetDays = 0) {
  const now = new Date(Date.now() + offsetDays * 86400000);
  return new Intl.DateTimeFormat("en-CA", { timeZone: "Asia/Kuala_Lumpur" }).format(now);
}
